/* global lp, jui, Class, $H, ga */

(function(){
  lp.editor.DynamicTextUpsellDialog = Class.create(jui.ModalPanel, {

    /**
     *
     * Public
     *
     **/

    KEYCODES : {
      enter:  13,
      esc  :  27
    },

    options: function($super, options) {
      return $super($H({attributes:{id:'dynamic-text-overlays'}}).merge(options));
    },

    initialize: function($super, options){
      $super(options);
    },

    installUI: function($super) {
      $super();
      this.dialogWrapper    = this._dialogWrapper();
      this.dialogWindow     = this._dialogWindow();

      this.header           = this._header();

      this.dialogFeatureInfo = this._dialogFeatureInfo();

      this.footer           = this._footer();

      this.okButton         = this._okButton();
      this.cancelButton     = this._cancelButton();
      this.closeButton      = this._closeButton();

    },

    open: function($super/*, defaultText, attributes , callback */) {
      $super();
      if (window.ga && window.ga !== undefined) {
        ga('send', 'event', 'modal', 'view', 'DTR Upsell From Builder');
      }
    },

    close: function($super) {
      $super();
      if (this.options.onClose) { this.options.onClose(); }
      // this.fireEvent('onDynamicTextUpsellDialogWindowClose', this);
    },

    /**
     *
     * Private
     *
     **/

    _dialogWrapper: function() {
      return this.content.insert(new jui.Component({
        attributes: {className: 'dynamic-wrapper upsell'}
      }));
    },

    _dialogWindow: function() {
      return this.dialogWrapper.insert(new jui.Component({
        attributes : {className : 'clearfix dynamic-text-dialog condensed'}
      }));
    },

    _header: function() {
      var header = this.dialogWindow.insert(
        new Element('header', { className: 'dynamic-dialog-title' })
      );

      this.title = new Element('h2');
      this.title.innerHTML = 'You\'ll need to upgrade to use Dynamic Text&hellip;';

      header.insert(this.title);
      return header;
    },


    _dialogFeatureInfo: function() {
      var dialogFeatureInfo = this.dialogWindow.insert(new jui.Component({
        attributes: { className: 'dialog-feature-upsell' }
      })),
      heading = new Element('h2')
        .update("Dynamically replacing text on your pages will help you increase the quality score, ad rank and message match of your paid advertising by passing in text using URL parameters.");

      var videoIframe = new Element('iframe', {
        src: '//fast.wistia.net/embed/iframe/75urte6v0j?videoFoam=true',
        allowtransparency: true,
        frameborder: 0,
        scrolling: 'no',
        class: 'wistia_embed',
        name: 'wistia_embed',
        allowfullscreen: 'allowfullscreen',
        mozallowfullscreen: 'mozallowfullscreen',
        webkitallowfullscreen: 'webkitallowfullscreen',
        oallowfullscreen: 'webkitallowfullscreen',
        msallowfullscreen: 'webkitallowfullscreen',
        width: 500,
        height:281
      });

      var videoScript = new Element('script', {
        src: '//fast.wistia.net/assets/external/iframe-api-v1.js'
      });

      var details = new Element('p', {
        className: 'upsell-details'
      }).update("Dynamic Text Replacement is available on all Pro plans.");

      dialogFeatureInfo.insert(heading);
      dialogFeatureInfo.insert(videoIframe);
      dialogFeatureInfo.insert(videoScript);
      dialogFeatureInfo.insert(details);
      return dialogFeatureInfo;
    },


    _footer: function() {
      var footer = this.dialogWindow.insert(new jui.Component({
        attributes: {
          className: 'dialog-footer clearfix'
        }
      }));
      var controls = footer.insert(
        new jui.Component({
          attributes: {
            className: 'right-controls'
          }
      }));
      return controls;
    },

    _okButton: function() {
      return this.footer.insert(new jui.Button({
        label  : 'Upgrade to use Dynamic Text',
        attributes: {
          tabindex: 5,
          className: 'continue btn medium blue right margin-left',
          target: '_blank'
        },
        action : function() {
          window.open('/change_subscription', '_blank');
          if (window.ga && window.ga !== undefined) {
            ga('send', 'event', 'button', 'click', 'DTR Upgrade From Builder');
          }
        }
      }));
    },

    _cancelButton: function() {
      return this.footer.insert(new jui.Button({
        label  : 'Cancel',
        attributes: {
          tabindex: 4,
          className: 'right btn medium light cancel'
        },
        action : this.close.bind(this)
      }));
    },

    _closeButton: function() {
      return this.footer.insert(new jui.Button({
       label       : 'Close',
        attributes  : {
          className : 'dynamic-close'
        },
        action      : this.close.bind(this)
      }));
    }

  });

})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/dynamic_text_upsell_dialog.js
// module id = 1020
// module chunks = 0